export default "__VITE_ASSET__5d06e794__"